import React from 'react'
import { Provider } from 'react-redux'

import { default as Survey } from './components/survey.jsx'

import { default as store, loadResponses, loadScores, loadLink, loadExitLink } from './store.js'

import { load as loadSurvey }      from '../../cyber/shared/ducks/survey.js'
import { loadWithReviewAndSubmit } from '../../cyber/shared/ducks/coverage_types.js'
import { load as loadLookup }      from '../../cyber/shared/ducks/lookups.js'


const CyberSurveyFrontend = (props) => {
    store.dispatch(loadSurvey(props))
    store.dispatch(loadWithReviewAndSubmit(props))
    store.dispatch(loadResponses(props.responses))
    store.dispatch(loadScores(props.scores))
    store.dispatch(loadLookup('tier', props.meta.tier))
    store.dispatch(loadExitLink(props.meta.saveAndExitLink))
    store.dispatch(loadLink(props.meta.cyberLink))

    return (
        <Provider store={ store }>
            <Survey />
        </Provider>
    )
}

export default CyberSurveyFrontend
